import { createContext, useContext, useState } from "react";
import { useSelection } from "./SelectionContext";
import { validateApiCallback } from "../utils/validateApiCallback";

const ClipBoardContext = createContext();

export const ClipBoardProvider = ({ children, onPaste, onCut, onCopy }) => {
  const [clipBoard, setClipBoard] = useState(null);
  const { selectedFiles, setSelectedFiles } = useSelection();

  const handleCutCopy = (isMoving) => {
    // Проверяем, есть ли выбранные файлы
    if (!selectedFiles || selectedFiles.length === 0) {
      console.warn("No files selected for cut/copy");
      return;
    }
    
    setClipBoard({
      files: selectedFiles,
      isMoving: isMoving,
    });

    if (isMoving) {
      !!onCut && onCut(selectedFiles);
    } else {
      !!onCopy && onCopy(selectedFiles);
    }
  };

  const handlePasting = (destinationFolder) => {
    // ВАЖНО: проверяем clipBoard на null/undefined
    if (!clipBoard) {
      console.warn("Clipboard is empty");
      return;
    }
    
    // ВАЖНО: проверяем files на null/undefined
    if (!clipBoard.files || !Array.isArray(clipBoard.files) || clipBoard.files.length === 0) {
      console.warn("No files in clipboard");
      return;
    }
    
    if (destinationFolder && !destinationFolder.isDirectory) return;

    const copiedFiles = clipBoard.files;
    const operationType = clipBoard.isMoving ? "move" : "copy";

    validateApiCallback(onPaste, "onPaste", copiedFiles, destinationFolder, operationType);

    if (clipBoard.isMoving) {
      setClipBoard(null);
    }
    setSelectedFiles([]);
  };

  return (
    <ClipBoardContext.Provider value={{ clipBoard, setClipBoard, handleCutCopy, handlePasting }}>
      {children}
    </ClipBoardContext.Provider>
  );
};

export const useClipBoard = () => useContext(ClipBoardContext);